import api from '../api';

export const paymentsApi = api.injectEndpoints({
  endpoints: builder => ({
    getPlans: builder.query({
      query: () => ({
        url: '/api/payment/plans/v1/fetch/plans',
        method: 'GET'
      })
    }),
    createPlan: builder.mutation({
      query: ({
        planId,
        finalAmount,
        couponApplied,
        selectedModules,
        userId,
        couponCodeId
      }) => ({
        url: '/api/v1/payments/generate/payment/link',
        method: 'POST',
        body: {
          userId,
          planId,
          selectedModules,
          couponApplied,
          finalAmount,
          couponCodeId
        }
      })
    }),
    createMockPlan: builder.mutation({
      query: ({
        userId,
        planId,
        selectedModules,
        finalAmount,
        couponCodeId,
        couponApplied
      }) => ({
        url: '/api/v1/payments/mock/test/generate/payment/link',
        method: 'POST',
        body: {
          userId,
          planId,
          selectedModules,
          finalAmount,
          couponCodeId,
          couponApplied
        }
      })
    }),
    getCoupns: builder.query({
      query: () => ({
        url: '/api/coupons/get/available',
        method: 'GET'
      })
    }),
    validateCoupon: builder.mutation({
      query: body => ({
        url: '/api/coupons/validate',
        method: 'POST',
        body
      })
    })
  })
});

export const {
  useGetPlansQuery,
  useCreatePlanMutation,
  useGetCoupnsQuery,
  useValidateCouponMutation,
  useCreateMockPlanMutation
} = paymentsApi;
